// extracted by mini-css-extract-plugin
export default {"confirmation":"submitModal_confirmation__TubYo","pdf":"submitModal_pdf__Dwmd0","spinner":"submitModal_spinner__jl8NK"};